import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const BarChart = (props) => {
    // Extracting labels from the data
    const labels = props.data.map(item => item.name || item.day);

    // // Extracting counts from the data
    const counts = props.data.map(item => item.count);


    const data = {
        labels: labels,
        datasets: [
            {
                label: `${props.label}`,
                data: counts,
                backgroundColor: `${props.color}`,
            }
        ],
    };

    return <Bar options={props.options} data={data} />;
}

export default BarChart;
